module.exports = __webpack_public_path__ + "static/img/reporticon4.42d54542.png";